/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * The version of the OpenAPI document: 1.0.31
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ChildrenUUID } from '../model/models';
import { ProfileCopyTokenOpenApi } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ProfileCopyTokensApiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * getProfileCopyTokensBasic
     * Generate profile copy tokens
     * @param childrenUUID 
     */
    getProfileCopyTokensBasic(childrenUUID: ChildrenUUID, extraHttpRequestParams?: any): Observable<{ [key: string]: any; }>;

    /**
     * getProfileCopyTokensBasicData
     * Generate profile copy tokens
     * @param childrenUUID 
     */
    getProfileCopyTokensBasicData(childrenUUID: ChildrenUUID, extraHttpRequestParams?: any): Observable<ProfileCopyTokenOpenApi>;

}
